import './styles/theme.scss'
import './styles/admin/theme.scss'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './i18n'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { adminPermissionDirective } from './apps/admin/directives/permission'

// 初始化代理信息
import { initAgentInfo } from './stores/portal/agentStore'

// Admin 入口不得初始化或清理 Portal 代理状态
if (!window.location.pathname.startsWith('/admin')) {
  initAgentInfo()
}

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.directive('admin-permission', adminPermissionDirective)
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
